module.exports = __webpack_public_path__ + "static/media/geoffpleiss_cv.55832a7f.pdf";